/**
 * Brand configuration — single source of truth for site identity,
 * navigation labels, contact email, and logo asset paths.
 *
 * Logo assets live in `public/images/etf/` and are downloaded by the
 * routing-assets teammate as part of static asset migration. The
 * components consume the URLs declared here.
 */
export const BRAND = {
  siteName: "Corgi Funds",
  title: "Corgi Funds — ETFs for the Future",
  description:
    "ETFs designed to offer direct access to disruptive themes and companies shaping the future.",
  canonical: "https://corgifunds.com",
  faviconUrl: "/corgifunds-favicon.png",
  contactEmail: "operations@founderledfunds.com",
  logos: {
    /** Wordmark used on dark backgrounds (default dark theme). */
    dark: "/images/etf/corgifunds-logo-light.webp",
    /** Wordmark used on light backgrounds (data-theme="light"). */
    light: "/images/etf/corgifunds-logo-orange.webp",
  },
  colors: {
    primary: "#ff5500",
  },
  parentCompany: {
    name: "The Corgi Company",
    url: "https://www.corgi.com",
  },
} as const;

export type Brand = typeof BRAND;
